import React, {useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {MapContainer, Marker, Popup, TileLayer} from "react-leaflet";
import 'leaflet/dist/leaflet.css'
import SectionTitle from "./SectionTitle";
import '../assets/css/sigmap.css';
import MultiLingualContent from '../config/multilingualContent';
import {LanguageContext} from "../config/multilingualContext";

const SigMap = () => {
      const { language, toggleLanguage } = useContext(LanguageContext);

    return (
        <div className="container about-list-items mb-5">
            <SectionTitle pageTitle="sig"/>
            <div style={{ width: '100%', height: '80vh' }}>
                <iframe
                    src="http://192.162.68.100/"
                    title="SIG Map"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    allowFullScreen
                />
            </div>
        </div>
    );
};

export default SigMap;